export default __webpack_public_path__ + "static/media/pen.cccff7c5.svg";